export default __webpack_public_path__ + "static/media/event-one.687eb751.png";